module.exports = __webpack_public_path__ + "img/deploy.2de8855.svg";